import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

function ListOfTitle({ searchData, clickEvent }) {
  return (
    <div className="b-container-listTitle">
      {searchData &&
        searchData.map((search) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div
            className="b-container-listTitle__title"
            onClick={() => clickEvent(search)}
          >
            <Typography className="dafault-font-family b-container-listTitle__typography">
              {search.title}
            </Typography>
          </div>
        ))}
    </div>
  );
}

ListOfTitle.propTypes = {
  // searchData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  searchData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  clickEvent: PropTypes.func.isRequired,
};
export default ListOfTitle;
